export default __webpack_public_path__ + "web/react/components/app-benefits-feed-item/images/icon-large.4133767d7aff0c8229cd3e73b4c8c76a.png";